import * as React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import {RxLapTimer} from "react-icons/rx";
import Navbar from "../../Layouts/Navbar";
import {RiListCheck3} from "react-icons/ri";


export default function VendorsReport() {
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [dateFrom, setDateFrom] = React.useState('');
    const [dateTo, setDateTo] = React.useState('');
    const [duration, setDuration] = React.useState('بازه انتخابی');
    const [vendors, setVendors] = React.useState([]);
    const [basics, setBasics] = React.useState([]);
    const [brand, setBrand] = React.useState('');


    let sumAll = 0;
    let sumSale = 0;
    let sumReturn = 0;

    React.useEffect(() => {

        const params = {
            processFor: 'Sales',
        }
        API.getBasics(params)
            .then((response) => {
                setBasics(response.data)
                setIsLoaded(true)
            })
            .catch((error) => {

            });

    }, []);


    const onLoadReport = () => {


        if(dateFrom.length < 3 || dateTo.length < 3) {
            toast.error('بازه تاریخی را انتخاب کنید');
            return false
        }

        const toMonth = dateTo?.toDate?.().getMonth() -(-1);
        const fromMonth = dateFrom?.toDate?.().getMonth() -(-1);
        const params = {
            date_from : dateFrom?.toDate?.().getFullYear() + '-' + fromMonth + '-' + dateFrom?.toDate?.().getDate() + ' 00:00' ,
            date_to : dateTo?.toDate?.().getFullYear() + '-' + toMonth + '-' + dateTo?.toDate?.().getDate() + ' 23:59' ,
            brand_id: brand
        }
        setIsLoaded(false)
        setDuration('بازه انتخابی')
        API.getVendorsReport(params)
            .then((response) => {
                setIsLoaded(true);
                setVendors(response.data.vendors)
            })
            .catch((error) => {

                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

    }

    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header hasBack={true} title='NGKH'/>
            <Navbar page="reports"/>
            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <RiListCheck3 className='ms-2' />
                        مدیریت نمایندگان
                    </h1>

                </div>
            <section className='section my-3 py-5 rtl'>
                <div className="row">
                    <div className="col-12">
                        <div className="card info-card ">

                            <div className="card-body rtl row pt-4">
                                <div className="col-5 mb-2">
                                <span className='text-small-2 mx-3'>
                                    از تاریخ
                                </span>
                                    <DatePicker
                                        onChange={(val) => setDateFrom(val)}
                                        calendar={persian}
                                        locale={persian_fa}
                                        calendarPosition="bottom-right"
                                        className="rmdp-mobile"

                                    />
                                </div>
                                <div className="col-1">
                                    &nbsp;
                                </div>
                                <div className="col-5 mb-2">
                            <span className='text-small-2 mx-3'>
                                    تا تاریخ
                                </span>
                                    <DatePicker
                                        onChange={(val) => setDateTo(val)}
                                        calendar={persian}
                                        locale={persian_fa}
                                        calendarPosition="bottom-right"
                                        className="rmdp-mobile"

                                    />
                                </div>
                                <div className="col-12 mb-3">
                                    <label htmlFor="floatingInput" className="mb-2 text-muted text-small-3">
                                        برند
                                    </label>
                                    <select
                                        className="form-control text-center text-small-1"
                                        id="floatingInput"

                                        value={brand}
                                        onChange={
                                            (event) => {
                                                setBrand(event.target.value)
                                            }
                                        }
                                    >
                                        <option value="0">
                                            انتخاب برند
                                        </option>
                                        {
                                            basics?.brands?.map(bt => {
                                                return (
                                                    <option value={bt.id} key={bt.id}>
                                                        {bt.name}
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                                <div className="col-12 mb-2">
                                    <button className='btn btn-warning w-100 text-small-2'
                                            onClick={onLoadReport}
                                    >
                                        مشاهده گزارش
                                    </button>
                                </div>
                                {
                                    vendors.length < 1 &&
                                    <div className="col-12 mt-3">
                                        <div className="alert alert-warning alert-dismissible fade show text-center text-small-2 " role="alert">
                                            <RxLapTimer className='ms-2' />
                                            توجه داشته باشید که به دلیل حجم بالای اطلاعات قابل پردازش، دریافت این گزارش -بسته به بازه انتخابی- ممکن است تا حدود ۲۰ ثانیه  طول بکشد. لطفا برای دریافت گزارش صبور باشید

                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className=' mt-3 alert alert-light text-center'>
                            گزارش عملکرد نمایندگان در
                            &nbsp;
                            {
                                duration
                            }
                        </div>
                        <table className="table rtl mt-1 table-striped">
                            <thead className='text-small-2'>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">نماینده</th>
                                <th scope="col">تعدادی</th>
                                <th scope="col">آمپری</th>
                                <th scope="col">برگشتی</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                vendors.map((vendor, index) => {
                                    sumAll += parseInt(vendor.bcount);
                                    sumSale += parseInt(vendor.ampsum);
                                    sumReturn += parseInt(vendor.returnb);
                                    return (
                                        <tr key={index}>
                                            <th scope="row">{index + 1}</th>
                                            <td>{vendor.title}</td>
                                            <td>{vendor.bcount}</td>
                                            <td>{vendor.ampsum}</td>
                                            <td>{vendor.returnb}</td>
                                        </tr>
                                    )
                                })
                            }
                            <tr >
                                <th scope="col" className='text-success'></th>
                                <th scope="col" className='text-success'>مجموع</th>
                                <th scope="col" className='text-success'>{ sumAll }</th>
                                <th scope="col" className='text-success'>{ sumSale }</th>
                                <th scope="col" className='text-success'>{ sumReturn }</th>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
            </main>

        </React.Fragment>
    );

}